exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-radio-v2 .ant-radio .ant-radio-checked .ant-radio-inner{background-color:#47af46}.cap-radio-v2 .ant-radio .ant-radio-inner:after{background-color:#fff}.cap-radio-v2 .inductive-text{padding-left:1.714rem;padding-top:.285rem}.cap-radio-v2 .title.has-suffix{margin-right:8px}.cap-radio-v2 .ant-radio-wrapper{font-size:12px;font-family:\"Roboto\",sans-serif}.cap-radio-v2 .ant-radio-wrapper.ant-radio-wrapper-disabled .inductive-text,.cap-radio-v2 .ant-radio-wrapper.ant-radio-wrapper-disabled .title{color:#97a0af}\n", ""]);

// exports
